import axiosInstance from "../axiosInstance";

export const forecastArtifactService = {
  // Starts (or restarts) generating the artifact for a product. Returns the
  // `pending` record almost immediately — the actual generation (data pull +
  // Kaman workflow, a couple of minutes) runs in the background on the
  // server and arrives later over WebSocket as a `forecastArtifactReady`
  // message (see websocketManager.js), or can be picked up with `get`.
  //
  // `engine`: "demand_forecast" for the admin Updated Forecast page's own
  // artifact (built from that engine's runs); omitted → the planning pages'.
  // `clientId`: required for admins (a client user's token carries it).
  generate: async (product, { engine, clientId, ...options } = {}) => {
    const response = await axiosInstance.post("/forecast-artifact-data", {
      product,
      ...(engine && { engine }),
      ...(clientId && { client_id: clientId }),
      ...options,
    });
    return response.data;
  },

  // The latest stored artifact for a product — `{ status: "none" }` if one
  // has never been generated, else `{ status: "pending"|"ready"|"error",
  // data?, narrative?, error? }`. Used to hydrate on mount/reload instead of
  // always waiting on a fresh generation.
  get: async (product, { engine, clientId } = {}) => {
    const params = [];
    if (engine) params.push(`engine=${encodeURIComponent(engine)}`);
    if (clientId) params.push(`client_id=${encodeURIComponent(clientId)}`);
    const response = await axiosInstance.get(
      `/forecast-artifact-data/${product}${params.length ? `?${params.join("&")}` : ""}`,
    );
    return response.data;
  },
};
